import { render, staticRenderFns } from "./CookieBox.vue?vue&type=template&id=8d2bf90e&scoped=true&"
import script from "./CookieBox.vue?vue&type=script&lang=js&"
export * from "./CookieBox.vue?vue&type=script&lang=js&"
import style0 from "./CookieBox.vue?vue&type=style&index=0&id=8d2bf90e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d2bf90e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8d2bf90e')) {
      api.createRecord('8d2bf90e', component.options)
    } else {
      api.reload('8d2bf90e', component.options)
    }
    module.hot.accept("./CookieBox.vue?vue&type=template&id=8d2bf90e&scoped=true&", function () {
      api.rerender('8d2bf90e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-26K0aBrqqIhnN/JS/comp/CookieBox.vue"
export default component.exports